<template>
    <div></div>
</template>

<script>
import InsideEntryFormFooterBar from './InsideEntryFormFooterBar.js';
export default InsideEntryFormFooterBar;
</script>
